<template lang="pug">
  .clientContacts.white
    rc-filter-table(
      ref="contactTable"
      :items="contacts"
      :headers="headers"
      :clickToVisit="clickToVisit"
      :loading="loading"
      :totalItems="typeof metadata === 'undefined' ? 0 : metadata.count"
      @sendEmit="emitEvent"
      @mounted="getData"
      @recall="getData"
      @deleteSelection="deleteSelection"
      @tableSearchAction="goToDetails"
    )
      template(slot="referentProducts" slot-scope="{ props }")
        v-chip(v-for="product in props.item.referentProducts" :key="product") {{product}}
      template(slot="actions" slot-scope="{ props }")
        v-btn(flat icon :to="`/users/${props.item.id}`")
          v-icon search
</template>

<script>
import RcFilterTable from '@/components/RcTable/RcTable.vue';
import axios from 'axios';
import apiContactService from '@/services/api/ambassador/contactService';

export default {
  components: {
    RcFilterTable,
  },
  props: {
    clientId: {
      type: [String, Number],
      default: 'all',
    },
    customActions: {
      type: Array,
      default: () => [],
    },
    clickToVisit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      contacts: [],
      metadata: undefined,
      loading: false,
      headers: [
        {
          label: '',
          type: 'selection',
          sortable: false,
          column: 'id',
          padding: 'left',
          width: '70px',
        },
        {
          label: '',
          type: 'avatar',
          column: 'image_url',
          partnerType: 'contact',
          center: true,
          padding: 'none',
          width: '80px',
        },
        {
          label: 'Nom',
          // sortable: true,
          column: 'last_name',
          filters: {
            type: 'text',
            operands: ['ilike'],
            entity: 'res_partner_for_client',
          },
        },
        {
          label: 'Prénom',
          // sortable: true,
          column: 'first_name',
          filters: {
            type: 'text',
            operands: ['ilike'],
            entity: 'res_partner_for_client',
          },
        },
        {
          label: 'Compte',
          // sortable: true,
          column: 'parent_name',
          type: 'route',
          filters: {
            type: 'text',
            operands: ['ilike'],
            field:  'name',
            entity: 'parent',
          },
          to: {
            name: 'client_contacts',
            params: {
              clientId: 'parent_id',
            },
          },
        },
        {
          label: 'Type de contact',
          // sortable: true,
          column: 'type_ids',
          type: 'types_list',
          filters: {
            type: 'autocomplete',
            operands: ['in'],
            values: this.$store.state.contacts.searchTypes,
            label: 'display_name',
            field: 'id',
            entity: 'res_partner_contact_type',
          },
        },
        {
          label: 'Login',
          // sortable: true,
          column: 'user.login',
          filters: {
            type: 'text',
            operands: ['ilike'],
            field: 'c.login',
          },
          adminOnly: true,
        },
        {
          label: 'Email',
          // sortable: true,
          column: 'email',
          filters: {
            type: 'text',
            operands: ['ilike'],
            entity: 'res_partner_for_client',
          },
        },
        {
          label: 'Téléphone',
          // sortable: true,
          column: 'phone',
          filters: {
            type: 'text',
            operands: ['ilike_remove_space_and_point'],
            entity: 'res_partner_for_client',
          },
        },
        {
          label: 'Produits',
          type: 'product_groups',
          sortable: false,
          column: 'contact_products',
          adminOnly: true,
        },
        {
          label: 'Accès STUDIO',
          type: 'access',
          sortable: false,
          column: 'user',
          center: true,
          align: 'center',
          filters: {
            values: [
              { label: 'Tous les utilisateurs', value: '' },
              { label: 'Avec un accès STUDIO', value: 'is not null' },
              { label: 'Sans accès STUDIO', value: 'is null' },
            ],
            default: { label: 'Tous les utilisateurs', value: '' },
            operands: [],
            customOperand: true,
            type: 'select',
            field: 'ru.partner_id',
          },
          adminOnly: true,
        },
        {
          label: 'Actions',
          type: 'actions',
          padding: !!this.customActions.length ? '' : 'none',
          buttons: [
            ...this.customActions,
          ],
        },
      ],
      addUserDialog: false,
    };
  },
  methods: {
    emitEvent(data) {
      this.$emit(data.emitName, data.value);
    },
    async getData({ size = 100, start = 0, filters = [] }) {
      this.loading = true;
      const contactResponse = filters.length ? await apiContactService.search(size, start, filters) : await apiContactService.get(size, start);
      this.contacts = contactResponse.data;
      this.metadata = contactResponse.metadata;
      this.loading = false;
    },
    async deleteSelection(selected) {
      this.loading = true;
      await apiContactService.deleteByIds(selected.map(it => it.id));
      this.$refs.contactTable.selected = [];
      this.getData({});
    },
    goToDetails(data) {
      this.$router.push(`/clients/contacts/${data.id}`);
    },
  },
};
</script>
